/**
 * The User session related query parameters.
 * @type {Object<String>}
 */
export const QUERY_PARAMS = {
    SHOW_JOIN: 'show_join',
    REFERRAL_EMAIL: 'referral_email'
};

/**
 * The session storage key for managing an auto shown sign up modal.
 * @type {string}
 */
export const SIGN_UP_AUTO_SHOWN_KEY = 'sign_up_auto_shown';

/**
 * The auto show trigger reason to be reported on auto show sign up flow.
 * @type {string}
 */
export const AUTO_SHOW_TRIGGER = 'system_trigger';

/**
 * The User session modal handler types
 * @type {Object<String>}
 */
export const HANDLER_TYPES = {
    SIGN_IN: 'sign_in',
    SIGN_UP: 'sign_up'
};

/**
 * The User session trigger selector mapped by the handler type.
 * @type {Object<String>}
 */
export const TRIGGER_SELECTORS = {
    [HANDLER_TYPES.SIGN_IN]: '.js-open-popup-login',
    [HANDLER_TYPES.SIGN_UP]: '.js-open-popup-join'
};

/**
 * The User session fallback route mapped by the handler type.
 * @type {Object<String>}
 */
export const FALLBACK_ROUTES = {
    [HANDLER_TYPES.SIGN_IN]: 'login',
    [HANDLER_TYPES.SIGN_UP]: 'join'
};
